import { BaseService, Service } from "/@/cool";

@Service("orderTag")
class OrderTag extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["saveProcessType"] = prefix + "saveProcessType";
		this.permission["processTypeOptions"] = prefix + "processTypeOptions";
	}

	saveProcessType(data: { order_id: number; tag_id: number }) {
		return this.request({
			url: "/saveProcessType",
			method: "POST",
			data
		});
	}

	processTypeOptions() {
		return this.request({
			url: "/processTypeOptions",
			method: "POST"
		});
	}
}

export default OrderTag;
